<template>
    <div v-if="hasAttachments" class="attachments">
        <div v-for="(a, ind) in attachmentList" :key="ind" @click="downloadAttachment(ind)">
            <div class="attachment">
                <FontAwesomeIcon class="atticon" :icon="getIcon(`${a.type}`)"></FontAwesomeIcon>
                <span class="attname">{{$t('messageView.attachmentName', { name: a.name })}}</span>
                <span class="attsize">{{$t('messageView.attachmentSize', { size: a.size })}}</span>
                <span class="attloader" v-if="loading[ind]">
                    <FontAwesomeIcon spin icon="spinner-third"></FontAwesomeIcon>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import MimeTypes from '@/helpers/MimeTypes';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import axios from 'axios';

export default {
  name: 'attachmentsViewer',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      loading: {}
    };
  },
  props: {
    attachments: Array,
    folderId: Number,
    message: Number
  },
  methods: {
    getIcon(type) {
      return MimeTypes.getIcon(type);
    },
    downloadAttachment(ind) {
      const fileName = this.attachmentList[ind].name;
      this.$set(this.loading, ind, true);
      axios.get(`/rest/user/folders/${this.folderId}/${this.message}/attachment/${this.attachmentList[ind].id}`)
        .then(d => {
          console.log('attach ', fileName, d);
          var el = document.createElement('a');
          el.setAttribute('href', d.data.data);
          el.setAttribute('download', fileName);
          el.style.display = 'none';
          el.onload = () => {
            console.log('el loaded');
          };
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
          this.$set(this.loading, ind, false);
        });
    }
  },
  computed: {
    attachmentList() {
      return this.attachments
        .map((a, ind) => {
          let att = Object.assign({}, a);
          if ((att.attachment) && (att.name === '')) {
            att.name = 'Attachment';
          }
          att.index = ind;
          return att;
        })
        .filter(s => s.attachment);
    },
    hasAttachments() {
      return this.attachmentList.length;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .attachments {
        padding: 2px 0;
        border-bottom: 1px solid $generic-box-border;
        .attachment {
            display: inline-block;
            padding: 0 10px;
            .attname {
                cursor: pointer;
                margin-left: 5px;
                font-weight: bold;
            }
            .attsize {
                color: $gray-600;
                margin-left: 5px;
            }
            &:hover {
                background-color: $dark;
                .attname, .atticon, .attloader {
                    color: $light;
                }
            }
        }
    }

</style>
